import classes from './negativnaProgresija.module.css'
import classesK from '../kalkulatori.module.css'
import { useEffect, useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'

const NegativnaProgresija = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [data, setData] = useState({
    values: {
      serie1: ['', ''],
    },
    results: {
      serie1Results: ['-', '-', '-', '-'],
    },
  })

  const clearFields = () => {
    setData({
      values: {
        serie1: ['', ''],
      },
      results: {
        serie1Results: ['-', '-', '-', '-'],
      },
    })

    setShowInputArea(true)
    setSeries([{ id: 1 }])
  }

  const [error, setError] = useState(false)

  const calculateAll = () => {
    const updatedResults = { ...data.results }
    let totalStakeValue = 0

    Object.keys(data.values).forEach((serieKey) => {
      const [stake, odds] = data.values[serieKey].map(Number)

      if (stake && odds) {
        const potentialWinnings = stake * odds
        const loss = -stake
        const profitability = `Ulog: ${totalStakeValue + stake} x 2.00`

        updatedResults[`${serieKey}Results`] = [
          potentialWinnings.toFixed(2),
          loss.toFixed(2),
          (totalStakeValue + stake).toFixed(2),
          profitability,
        ]

        totalStakeValue += stake
      } else {
        updatedResults[`${serieKey}Results`] = ['-', '-', '-', '-']
      }
    })

    setData((prevData) => ({
      ...prevData,
      results: updatedResults,
    }))
  }

  useEffect(() => {
    calculateAll()
  }, [data.values])

  const [series, setSeries] = useState([{ id: 1 }])

  const addSeries = () => {
    setSeries((prevSeries) => {
      const newSeries = [...prevSeries, { id: prevSeries.length + 1 }]
      setData((prevData) => ({
        ...prevData,
        values: {
          ...prevData.values,
          [`serie${newSeries.length}`]: ['', ''], // Add new series to data.values
        },
        results: {
          ...prevData.results,
          [`serie${newSeries.length}Results`]: ['-', '-', '-', '-'], // Add new series results to data.results
        },
      }))
      return newSeries
    })
  }

  return (
    <div className={classesK.container}>
      <InfoBar
        calculatorType={`Negativna progresija`}
        onRefresh={clearFields}
      />
      <div className={classesK.contentContainer}>
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>Igra</div>
              {series.map((serie) => (
                <div key={serie.id} className={classes.seriesContainer}>
                  <div className={classes.seriesTitle}>
                    Serija br. {serie.id}
                  </div>
                  <div className={classes.seriesValues}>
                    <OddsCalculator
                      data={data.values}
                      setData={setData}
                      field={`serie${serie.id}`}
                      labelPrefix={['Upiši ulog', 'Upiši kvotu']}
                      step={['1', '0.1']}
                      min={['1', '0.1']}
                      type={['number', 'number']}
                      setError={setError}
                      rows={2}
                    />
                    <ResultsSection
                      names={[
                        'Eventualni dobitak',
                        'Gubitak u seriji',
                        'Ukupan dosadašnji ulog',
                        'Isplativost odnosa sledećeg uloga i kvote',
                      ]}
                      results={data.results[`serie${serie.id}Results`] || []}
                      rows={2}
                      allowNegative={true}
                    />
                  </div>
                </div>
              ))}
              {series.length < 25 && (
                <div className={classesK.addMore}>
                  <button onClick={addSeries} className={classesK.addButton}>
                    <img src={add} height={18} width={18} alt='image' />
                    Dodaj još jednu seriju
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default NegativnaProgresija
